quoteModule.controller('createQuoteController',
    ['$rootScope', '$scope', '$location', 'quoteCreationEvents','rateQuoteCoordService','rateQuotePersistService',
        'quoteIntegrationService','erateSessionVarsService','quoteIntegrationConstants','rateQuoteScenariosService', 'welcomeEvents',
        'providerFeatureEvents', '$controller','rateQuoteRetrievalCoordService', 'tuxFabMenuEvents','contractCreationService',
        'vehicleProductsProcessingService', 'vehicleDefinitionService','quoteInitializationService','TLCError','AppErrorCodes','$timeout', 'imSessionVarsService',
function ($rootScope, $scope, $location, quoteCreationEvents, rateQuoteCoordService, rateQuotePersistService,
          quoteIntegrationService, erateSessionVarsService, quoteIntegrationConstants,rateQuoteScenariosService, welcomeEvents,
          providerFeatureEvents, $controller, rateQuoteRetrievalCoordService,  tuxFabMenuEvents, contractCreationService,
          vehicleProductsProcessingService, vehicleDefinitionService, quoteInitializationService, TLCError, AppErrorCodes, $timeout, imSessionVarsService)
    {

        /*
        OK, for those who are interested... YES, the create-quote page is the most complex page that we have. It is
        the main page that does quoting AND contracting, so there is a lot going on here. Here are some important
        design structure elements:
            1. When vehicle attributes change, we send out an event, which should clear out any quotes, products, rates already there
            2. When vehicle attributes are "complete", we send out an event that will initiate quoting (getting products first)
            3. When financial attributes change, we send out an event, which should clear out any quotes, product, rates already there
            4. Retrieving a quote by session number fills in the customer, financial, and vehicle data.. which initiates
               product and quote retrieval. Saved quotes have the "rate/product cache id" which allows us to quickly
               recreate the product and quote data from the original rates.
            5. vehicle-products-coordination-service.js :: This has the most complex logic, because it handles keeping track
               of product coverages, deductibles, surcharges, and upgrades. Each "product" directive is assigned the
               appropriate internal product id, which serves as the "starting" point of all of the product data saved.
            6. rate-quote-scenarios-service.js :: This keeps track of the "proposals" that are set up with the quotes per proposal.
            7. rate-quote-retrieval-coord-service.js :: Responsible for retrieving a quote by quote session number. It uses the "cached"
               product and rates identifiers to pull up the original products and rates that "surround" the quote itself.
               When it is kicked off, we "flag" that we are "in quote retrieval". Once the quote is retrieved, once the user
               interacts with the page we turn the "flag" off. Not the most elegant way to know whether we are finished
               retrieving the quote, but at the moment it is the best we have.
            8. quote-integration-service.js/quote-integration-controller.js :: This service and controller handles transferring
               vehicle, customer, and deal data to the quoting screen. It is utilized by external application integration
               (MenuPro), and other screens within the application.
        */

        function showHidePFTab(showPT){
            if ((showPT) && (erateSessionVarsService.getQuotingMode() == quoteIntegrationConstants.menuQuoteIntegrated)) {
                $rootScope.$broadcast("SHOW-PF-TAB", true);
            }
        }

        $scope.startAQuote = function(){
            var providerCode = imSessionVarsService.getCurrentProviderCode();
            var dealerCode = erateSessionVarsService.getCurrentDealerAccountCode();
            if ($location.search()['qsession']){
                rateQuoteRetrievalCoordService.startQuoteRetrieval();

                var quoteSession = $location.search()['qsession'];

                rateQuoteCoordService.setQuoteSessionId(quoteSession);
                vehicleProductsProcessingService.getAllFilteringProductsByProvider(quoteSession, dealerCode, providerCode).then(
                    function doneProcessingAllProducts(doneData) {

                        showHidePFTab(doneData.showPT);
                        $rootScope.$broadcast(quoteCreationEvents.filteringProductRetrieved, doneData.data);
                        $rootScope.$broadcast(quoteCreationEvents.startNewProductQuote, {newguid: quoteSession});

                        //clearing the quote session id once we have it
                        //$location.search('');

                        contractCreationService.waitForContractChecks();//we will check for contracts at some point, so flag that for UI purposes

                        rateQuoteRetrievalCoordService.loadQuotesBySessionId(quoteSession)
                            .then(
                                function broadcastQuoteDataRetrieved(unused) {

                                    //if for some reason the vehicle or financial info
                                    // changes from the saved quote from another 'integration'
                                    // call, redirect so new quotes are created.
                                    if (!checkSavedQuoteDataOKAgainstIntegrationData()) {
                                        clearQuoteIdsOfIntegrationData();
                                        $location.url('/create-quote');
                                    } else {
                                        //we want to make sure if we are "re-integrating"
                                        // to update the quotes with the latest customer info
                                        reSynchCustomerDataFromIntegration();

                                        $rootScope.$broadcast(quoteCreationEvents.customerDataRetrieved,
                                            {});
                                        $rootScope.$broadcast(quoteCreationEvents.vehicleDataRetrieved,
                                            {});
                                        $rootScope.$broadcast(quoteCreationEvents.dealDataRetrieved,
                                            {});
                                        $rootScope.$broadcast(quoteCreationEvents.loadingExistingQuote, {});

                                        $rootScope.$broadcast(quoteCreationEvents.customerDataChange, {});//forcing customer card to refresh
                                    }
                                },
                                function quoteDataErr(err) {
                                    throw new TLCError(new Error(err), AppErrorCodes.CreateQuoteController_LoadQuoteError);
                                }
                            );
                    });
            }else{
                rateQuoteCoordService.getNewGuid(rateQuoteRetrievalCoordService.inQuoteRetrieval())
                .then(function(guid){
                    $rootScope.$broadcast(quoteCreationEvents.startNewProductQuote, {newguid: guid});
                    vehicleProductsProcessingService.getAllFilteringProductsByProvider(guid, dealerCode, providerCode).then(
                        function (doneData) {       // this should always be empty for not menu integration ....
                            showHidePFTab(doneData.showPT);
                            $rootScope.$broadcast(quoteCreationEvents.filteringProductRetrieved, doneData.data);
                            $rootScope.$broadcast(quoteCreationEvents.customerDataChange, {});//forcing customer card to refresh
                        }
                    );
                });
            }
        }



        quoteInitializationService.clearReadyStates();
        quoteInitializationService.registerCallbackHandler($scope.startAQuote, 'STARTAQUOTE')

        var reSynchCustomerDataFromIntegration = function(){
            var integrationCustomerData = quoteIntegrationService.getIntegratedCustomerData();

            if (integrationCustomerData){
                //re-synch with new any new customer fields
                quoteInitializationService.initializeCustomerData();
                $scope.saveQuotesProcess();
            }
        }
        var clearQuoteIdsOfIntegrationData = function(){
            var integrationData = quoteIntegrationService.getIntegrationData();

            if (integrationData.productsToQuote){
                integrationData.productsToQuote.forEach(function clearId(prod){
                    if (prod && prod.internalQuoteId)
                        prod.internalQuoteId = null;
                });
            }

            quoteIntegrationService.setIntegrationData(integrationData);
        }

        var checkSavedQuoteDataOKAgainstIntegrationData = function(){
            var savedVehicleData = rateQuoteCoordService.VehicleData;
            var integrationVehicleData = quoteIntegrationService.getIntegratedVehicleData();
            var savedFinancialData = rateQuoteCoordService.DealData;
            var integrationFinancialData = quoteIntegrationService.getIntegratedFinancialData();

            var allTheSame = true;
            //check if vehicle information has changed
            if (integrationVehicleData){
                var oldVin = savedVehicleData.vin ? savedVehicleData.vin.toUpperCase() : '';
                var newVin = integrationVehicleData.vin ? integrationVehicleData.vin.toUpperCase() : '';

                var oldOdo = parseInt(savedVehicleData.odometer);
                var newOdo = parseInt(integrationVehicleData.odometer);

                allTheSame &=  (oldVin === newVin) && (oldOdo === newOdo);
            }
            //
            //COM-808 we will no longer "invalidate" a quote if only the finance data changes
            // removed check when menu integrated.
            return allTheSame;
        }
        //scope variables that help us with the process
        $scope.quoteData = {
            financialDetailsReady: false,
            customerDetailsReady: false,
            chosenQuotesReady: false,
            showCustomerInfo: false,
            showVehicleInfo: false,
            showFinancialInfo: false,
            hasProductError: false,
            productErrorMessage: "",
            vehicleCtlDone : false,
            customerCtlDone: false,
            dealCtlDone: false
        };
        $scope.integrationTimerPromise = null;

        $scope.vehicleDetailsData = vehicleDefinitionService.vehicleDetailsData;

        $scope.showQueuingIntegration = false;
        $scope.showSendingIntegration = false;

        $scope.checkChildControls = function(){
            if ($scope.quoteData.vehicleCtlDone &&
                $scope.quoteData.customerCtlDone &&
                $scope.quoteData.dealCtlDone){
                $rootScope.$broadcast(quoteCreationEvents.startNewProductQuote, {});
            }
        }

        $scope.productData = vehicleProductsProcessingService.productData;

        $scope.quotingModeCQ = null;
        $scope.menuQuoteIntegrated = quoteIntegrationConstants.menuQuoteIntegrated;
        $scope.menuContractIntegrated = quoteIntegrationConstants.menuContractIntegrated;
        $scope.mastheadShowSearch = true;

        contractCreationService.initContractInfo();
        $scope.contractProcessing = contractCreationService.contractsProcessing;

        $scope.toggleShowCustomer = function(){
            $scope.quoteData.showCustomerInfo = !$scope.quoteData.showCustomerInfo;
        };

        $scope.toggleShowVehicle = function(){
            $scope.quoteData.showVehicleInfo = !$scope.quoteData.showVehicleInfo;
        };

        $scope.toggleShowFinancials = function(){
            $scope.quoteData.showFinancialInfo = !$scope.quoteData.showFinancialInfo;
        };

        $scope.clearProductError = function(){
            $scope.hasProductError = false;
            $scope.productErrorMessage = null;
        }
        //vehicle data changed, so mark us as "vehicle not ready"
        $scope.$on(quoteCreationEvents.vehicleDataChanged, function(event, args) {
            $scope.vehicleDetailsData.ready = false;
            $scope.clearProductError();
            //$scope.productData.haveProducts = false;
        });

        $scope.isRVEligible = false;
        $scope.isAutoEligible = true;

        //initialization (nothing much here)
        $scope.init = function(){
            vehicleProductsProcessingService.onProductError(function(errorMsg) {
                $scope.hasProductError = true;
                $scope.productErrorMessage = errorMsg;
                throw new TLCError(new Error(errorMsg),AppErrorCodes.CreateQuoteController_ProductError);
            },'CREATE-QUOTE-PROD-ERROR');

            $scope.quotingModeCQ = erateSessionVarsService.getQuotingMode();
            $scope.showQueuingIntegration = false;
            $scope.showSendingIntegration = false;
            var vType = erateSessionVarsService.getCurrentDealerVehicleType();
            if (vType == null) {vType = 'AUTO';}
            $scope.isRVEligible = (vType == 'RV' || vType == 'RVAUTO') ? true : false
            $scope.isAutoEligible = (vType == 'AUTO' || vType == 'RVAUTO') ? true : false
        }
        //once all controls loaded, we signal we are ready to start a quote

        //creating a new proposal
        $scope.newQuoteScenario = function(copyScenarioId){
            if (!copyScenarioId){
                copyScenarioId = rateQuoteScenariosService.getCurrentScenario();
            }
            var newScenario = rateQuoteCoordService.addNewScenario(copyScenarioId);
            rateQuoteCoordService.setCurrentScenario(newScenario);
        }
        //save event
        $scope.$on(quoteCreationEvents.attemptQuoteSave, function(event, args) {
            $scope.saveQuotesProcess();
        });

        $scope.$on(quoteCreationEvents.productTypeChosen, function(event, args) {
            $scope.$broadcast(quoteCreationEvents.productTypeChosenEmit, args);
        });
        //save rates as quotes
        $scope.saveQuotesProcess = function(){
            if (rateQuoteRetrievalCoordService.inQuoteRetrieval())
                return;//hold off until done retrieving quote and setting up values

            if (!rateQuotePersistService.readyToSaveQuotes()) { //are all requirements met to save?
                return;
            }
            //save selected rates as quotes
            rateQuotePersistService.saveRatesAsQuotes()
                .then(
                function savedRatesSuccessfully(data){
                    $rootScope.$broadcast(quoteCreationEvents.saveRatesToCompleted,data);
                    //check our quoting mode (integrated or not)
                    var quoteMode = erateSessionVarsService.getQuotingMode();

                     if (quoteMode && quoteMode.toUpperCase() == quoteIntegrationConstants.menuQuoteIntegrated){
                        $scope.transferQuotesToIntegratedApp('MENUPRO');
                     }
                },
                function saveRateErr(err){
                    window.alert("Your product selection failed to save.  Please re-select your product price quote to continue.");
                    throw new TLCError(new Error(err),AppErrorCodes.CreateQuoteController_SaveQuoteError);
                });
        }
        //remove a proposal
        $scope.removeQuoteScenario = function(scenarioId){
            if (!scenarioId){
                scenarioId = rateQuoteScenariosService.getCurrentScenario();
            }
            //should we remove a scenario/proposal?
            if (!rateQuotePersistService.okToRemoveQuotes()){
                throw new TLCError(new Error('Not ready to remove quotes yet.'),AppErrorCodes.CreateQuoteController_SaveQuoteError);
            }
            else {
                rateQuotePersistService.removeQuoteScenario(scenarioId)
                    .then(
                    function removedQuoteScenarioSuccessfully(success) {
                        $rootScope.$broadcast(quoteCreationEvents.attemptQuoteSave,{});
                    },
                    function removeScenarioErr(err) {
                        throw new TLCError(new Error(err),AppErrorCodes.CreateQuoteController_SaveQuoteError);
                    }
                );
            }
        }
        //respond to removing quote from proposal
        $scope.$on(quoteCreationEvents.quoteRemovedFromScenario, function(event, args) {
            var quoteMode = erateSessionVarsService.getQuotingMode();
            if (quoteMode && quoteMode.toUpperCase() == quoteIntegrationConstants.menuQuoteIntegrated){
                $scope.transferQuotesToIntegratedApp('MENUPRO');
            }
        });
        //send quote info to MenuPro (or another app later)
        $scope.transferQuotesToIntegratedApp = function(applicationCode){

            $rootScope.$broadcast(quoteCreationEvents.queueUpIntegration,{});

            //if the user is clicking quickly thru
            // quotes, let's wait and see if they add more
            // quotes within 5 seconds. If they do, cancel the first
            // time-delayed transmit and start another.
            if ($scope.integrationTimerPromise) {
                $timeout.cancel($scope.integrationTimerPromise);
            }
            $scope.integrationTimerPromise = $timeout(
                function delaySendToIntegratedApp(){
                    //prepare the data for trasmission
                    $rootScope.$broadcast(quoteCreationEvents.sendIntegration,{complete: false});

                    quoteIntegrationService.prepDataForIntegrationSubmit(
                        rateQuoteCoordService.CustomerData,
                        rateQuoteCoordService.VehicleData,
                        rateQuoteCoordService.DealData,
                        rateQuoteCoordService.getHeldQuotesPerProposal(),
                        rateQuoteScenariosService.getScenarioList())
                        .then(
                            function quoteDataReady(preparedIntegrationData) {
                                //send the "quote data" back to the integrated APP
                                // MENUPRO is the default for now
                                quoteIntegrationService.signalIntegrationSendToApp(
                                    erateSessionVarsService.getIntegrationToken(),
                                    applicationCode,
                                    preparedIntegrationData)
                                    .then(
                                        function transferSuccess(ok){
                                            $rootScope.$broadcast(quoteCreationEvents.sendIntegration,{complete: true});
                                        },
                                        function transferErr(err){
                                            $rootScope.$broadcast(quoteCreationEvents.sendIntegration,{complete: true});
                                            throw new TLCError(new Error(err),AppErrorCodes.CreateQuoteController_MenuTransferError);
                                        });
                            },
                            function quoteDataNotReadyErr(err){
                                $rootScope.$broadcast(quoteCreationEvents.sendIntegration,{complete: true});
                                throw new TLCError(new Error(err),AppErrorCodes.CreateQuoteController_MenuTransferError);
                            }
                        );

                },
                5000 //waiting 5 seconds before we ship off integration..giving time for other "clicks" to be bundled up
            );
        };

        $scope.closeFabMenu = function () {
            $rootScope.$broadcast(tuxFabMenuEvents.closed,{});
        };

        $scope.$on(quoteCreationEvents.sendIntegration, function(event, args) {
            $scope.showQueuingIntegration = false;
            $scope.showSendingIntegration = true;
            $timeout(function() { $scope.showSendingIntegration = false; }, 1500);//after 3 seconds, stop showing
        });

        $scope.$on(quoteCreationEvents.queueUpIntegration, function(event, args) {
            $scope.showSendingIntegration = false;
            $scope.showQueuingIntegration = true;
            $timeout(function() { $scope.showQueuingIntegration = false; }, 1500);//after 3 seconds, stop showing
        });

        //initialize variables
        $scope.init();
    }
]);
